/* eslint-disable max-lines-per-function */
import React, {
    useCallback, useEffect, useMemo, useState
} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    menu, formatDateForComponent
} from '../utils/utils';
import { useCreateBundleOrder } from '../../../api/orders';
import _uniqueId from 'lodash/uniqueId';
import BulkInsertTable from './Table';

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: '100%',
        borderCollapse: 'separate',
        borderSpacing: '0px 0px'
    },
    tableContainer: {
        borderRadius: 1,
        margin: '5px 5px',
        maxWidth: '100%',
        height: '650px'
    },
    tableHeaderCell: {
        fontWeight: 'bold',
        backgroundColor: theme.palette.primary.black,
        padding: 10
    },
    tableBody: {
        fontWeight: 'bold',
        padding: 0
    },
    name: {
        fontWeight: 'bold',
        color: theme.palette.secondary.dark
    },
    hover: {
        cursor: 'pointer'
    },
    center: {
        textAlign: 'center'
    },
    buttonSubmit: {
        backgroundColor: 'green'
    },
    buttonCancel: {
        backgroundColor: 'red',
        width: '100px'
    }
}));

const validate = orders => orders.map(x => {

    if (x.unit === '' || x.tag === '' || x.amenity_name === ''){
        return false;
    }

    return true;

});

const BulkInsert = props => {

    const {
        propertyId,
        amenity_types: amenityTypes,
        amenity_tags,
        unitTypeMappings,
        role,
        arrayAll: amenityNotes,
        allUnits,
        setModalOpen
    } = props;

    const [orders, setOrders] = useState({});
    const [buttonCloseLabel, setButtonCloseLabel] = useState('Close');
    const [buttonCloseClick, setButtonCloseClick] = useState(0);
    const [buttonSubmitLabel, setButtonSubmitLabel] = useState('Save Bulk');

    const unitMenu = useMemo(
        () => allUnits.map(
            key => ({
                key,
                value: key,
                label: key
            })
        ),
        [allUnits]
    );

    const amenityTags = useMemo(
        () => amenity_tags.map(a => ({
            key: a.name,
            value: a.name,
            label: a.name
        })),
        [amenity_tags]
    );

    const paidMenu = useMemo(
        () => (
            ['Yes', 'No'].map(
                key => ({
                    key,
                    value: key,
                    label: key
                })
            )
        ),
        []
    );

    const { mutate: createBundleOrder } = useCreateBundleOrder();
    const styles = useStyles();

    const makeAmenityList = useCallback(
        value => (

            menu(value, amenityTypes)
        ),
        [amenityTypes]
    );

    const findUnitType = useCallback(
        value => (
            // const order_element = amenityNotes.find(element => element.unit_space_name === value);
            unitTypeMappings[value]
            // return `${getUnitType(order_element, unitTypeMappings)}`;
        ),
        [unitTypeMappings]
    );

    const onSubmit = useCallback(async () => {

        const orderValues = Object.values(orders);
        const validationOK = validate(orderValues).every(x => x === true);

        if (!validationOK){
            setButtonSubmitLabel('Some required fields are missing');

            return ;
        }


        await createBundleOrder(
            orderValues.map(order => {


                const order_element = amenityNotes.find(element => element.unit_space_name === order.unit);
                const type_id = amenityTypes.find(
                    amenityType => amenityType.type === order.amenity_name
                );

                return {
                    unit_space_name: order.unit,
                    type_id: (type_id ? type_id.type_id : null),
                    amenity_name: order.amenity_name,
                    paid: order.paid === 'Yes',
                    date_paid: (order.date_paid) ? formatDateForComponent(order.date_paid) : null,
                    check_number: (order.check_number ? order.check_number : null),
                    ordered: (order.ordered) ? formatDateForComponent(order.ordered) : null,
                    manager_notes: (order.manager_notes ? order.manager_notes : null),
                    owner_notes: (order.owner_notes ? order.owner_notes : null),
                    lookup_code: order_element?.lookup_code || order.lookup_code,
                    property_id: propertyId,
                    custom: true
                };
            })
        );

        setModalOpen(false);

    }, [
        orders,
        createBundleOrder,
        propertyId,
        amenityNotes,
        amenityTypes,
        setModalOpen
    ]);

    const newOrder = useCallback(
        () => {

            const id = _uniqueId();

            const order = {
                id,
                unit: '',
                unit_type: '',
                tag: '',
                amenity_name: '',
                paid: 'No',
                date_paid: '',
                check: '',
                date_ordered: '',
                manager_notes: '',
                owner_notes: ''
            };

            orders[id] = order;

            setOrders({ ...orders });
        },
        [orders, setOrders]
    );

    const closeModal = () => {

        if (Object.keys(orders).length > 0 && buttonCloseClick === 0){
            setButtonCloseLabel('Are you sure?');
            setButtonCloseClick(buttonCloseClick + 1);
        }
        else if (Object.keys(orders).length > 0 && buttonCloseClick === 1){
            setModalOpen(false);
        }
    };

    const deleteOrder = useCallback(
        id => {

            delete orders[id];
            setOrders({ ...orders });
        },
        [orders, setOrders]
    );

    const saveOrder = useCallback(
        order => {

            orders[order.id] = order;
            setOrders(orders);
        },
        [orders, setOrders]
    );

    const data = useMemo(() => Object.values(orders), [orders]);


    useEffect(() => {

        newOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const tableProps = {
        data,
        styles,
        onSubmit,
        newOrder,
        deleteOrder,
        saveOrder,
        amenityTypes,
        amenityTags,
        amenityNotes,
        unitTypeMappings,
        role,
        unitMenu,
        paidMenu,
        makeAmenityList,
        findUnitType,
        closeModal,
        buttonCloseLabel,
        buttonSubmitLabel
    };

    return (
        <BulkInsertTable {...tableProps}/>
    );
};

export default BulkInsert;
